var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitchFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.25 62C124.25 27.7583 96.4917 0 62.25 0C28.0083 0 0.25 27.7583 0.25 62C0.25 96.2417 28.0083 124 62.25 124C96.4917 124 124.25 96.2417 124.25 62Z",
    fill: "#9146FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7583 36.534L35.6869 47.6054V87.4625H48.9726V98.534L60.044 87.4625H68.9012L88.8298 67.534V36.534H46.7583ZM84.4012 65.3197L75.544 74.1768H66.6869L58.9369 81.9268V74.1768H48.9726V40.9625H84.4012V65.3197Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7583 48.7125H73.3298V61.9983H77.7583V48.7125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5798 48.7125H61.1512V61.9983H65.5798V48.7125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchFooter);
export default __webpack_public_path__ + "static/media/twitchFooter.304b6626fdcb0add896cc1e6f433eb8e.svg";
export { ForwardRef as ReactComponent };